import './TabbedView.less';
import React from 'react';

export default class TabbedView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0
    };
  }

  setActiveIndex = (activeIndex) => {
    this.setState({activeIndex});
  };

  render() {
    const {tabs, children, useHtmlStyleForHiding} = this.props;
    const {activeIndex} = this.state;

    return <div className="tabbed-view">
      <div className="tabs">
        <ul>
          {
            tabs.map((tab, index) => <li
              key={String(index)}
              onClick={() => this.setActiveIndex(index)}
              className={index === activeIndex ? ' active' : ''}
            >
              {tab}
            </li>)
          }
        </ul>
      </div>
      {
        useHtmlStyleForHiding
          ?
          children.map((child, index) => <div
            key={String(index)}
            className="tab-content"
            style={{display: index === activeIndex ? 'block' : 'none'}}
          >
            {child}
          </div>)
          :
          <div className="tab-content">
            {children[activeIndex]}
          </div>
      }
    </div>;
  }
}